<!--维修订单详细页-->
<template>
    <div>
        <van-sticky>
            <div style="padding: 10px 0px 0px 0px">
                <van-icon name="arrow-left" size="20px" @click="onback"/>
            </div>
        </van-sticky>
        <div class="content">
            <Card style="width:100%">
                <cell size="small" style="padding: 0px;">
                    <label>订单号：
                        <label style="color: #0077aa;">{{maintainOrdersDetail.orderNum}}</label>
                    </label><br/>
                </cell>

                <div class="mid">
                                <span class="count fl">车牌号:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo==null?'':maintainOrdersDetail.vehicleInfo.registrationNum}}</label>
                                </span>
                    <span class="distance fr">|</span>
                    <span class="time fr">车架号:
                                                                <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo==null?'':maintainOrdersDetail.vehicleInfo.vin}}</label>
                                                            </span>
                </div>
                <div class="mid">
                                <span class="count fl">发动机号:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo==null?'':maintainOrdersDetail.vehicleInfo.engineNum}}</label>
                                </span>
                </div>
                <div class="mid">
                    <span class="time fr">问题描述:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.question==null?'':maintainOrdersDetail.question}}</label>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">预约维修时间:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.bookingDatetime==null?'':new Date(maintainOrdersDetail.bookingDatetime).Format('yyyy年MM月dd日')}}</label>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">客户姓名:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo.clientInfo==null?'':maintainOrdersDetail.vehicleInfo.clientInfo.name}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                    <span class="distance fr">|</span>
                    <span class="time fr">客户电话:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo.clientInfo==null?'':maintainOrdersDetail.vehicleInfo.clientInfo.phoneNum}}</label>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">客户地址:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.vehicleInfo.clientInfo==null?'':maintainOrdersDetail.vehicleInfo.clientInfo.address}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">备注:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.remark==null?'':maintainOrdersDetail.remark}}</label>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">公司联系人:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.createUser==null?'':maintainOrdersDetail.createUser.nickName}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                    <span class="distance fr">|</span>
                    <span class="time fr">公司联系人电话:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.createUser==null?'':maintainOrdersDetail.createUser.mobilePhoneNum}}</label>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">订单业务员:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.businessUser==null?'':maintainOrdersDetail.businessUser.nickName}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                    <span class="distance fr">|</span>
                    <span class="time fr">订单业务员电话:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.businessUser==null?'':maintainOrdersDetail.businessUser.mobilePhoneNum}}</label>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">订单维修员:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.maintainer==null?'':maintainOrdersDetail.maintainer.nickName}}</label>
                                    <!--                                    <label style="color: #0077aa;">{{item.tempVehicleInfo.registrationNum}}</label>-->
                                </span>
                    <span class="distance fr">|</span>
                    <span class="time fr">订单维修员电话:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.maintainer==null?'':maintainOrdersDetail.maintainer.mobilePhoneNum}}</label>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">维修记录:
                                    <div v-for="maintainDeviceRecorditem in maintainOrdersDetail.maintainDeviceRecords">
                                    <label style="color: #0077aa;">{{maintainDeviceRecorditem.terminalNum==null?'':maintainDeviceRecorditem.terminalNum+'(' + maintainDeviceRecorditem.positioningDeviceInfo.positioningDeviceModel.name + ')'}}</label>
                                        <span class="distance fr">|</span>
                                        <label style="color: #0077aa;">{{maintainDeviceRecorditem.result==null?'未维修':maintainDeviceRecorditem.result}}</label>
                                    </div>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">订单状态:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.state==0?'作废':maintainOrdersDetail.state==1?'待指派':maintainOrdersDetail.state==2?'待维修':'维修完成'}}</label>
                                </span>
                    <span class="distance fr">|</span>
                    <span class="time fr">维修结果:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.result==null?'':maintainOrdersDetail.result}}</label>
                                </span>
                </div>
                <div class="mid">
                                <span class="count fl">历史记录:
                                    <label style="color: #0077aa;">{{maintainOrdersDetail.history}}</label>
                                </span>
                </div>
                <div class="mid">
<!--                    <Button size="small" type="info" @click="assignMaintenance()">指派维修员-->
<!--                    </Button>&nbsp;-->
<!--                    <Button size="small" type="info" @click="assignSalesman()">指定跟进业务-->
<!--                    </Button>&nbsp;-->
                    <Button size="small" type="info" @click="toUploadermaintainOrdersDetail(maintainOrdersDetail)">上传图片
                    </Button>&nbsp;
                </div>
                <div class="mid">
                    <Button size="small" type="info" @click="showmodel(maintainOrdersDetail)">添加维修记录
                    </Button>&nbsp;
                    <Button size="small" type="info" @click="showdeletemodel(maintainOrdersDetail)">删除维修记录
                    </Button>&nbsp;
                    <Button size="small" type="info" @click="showmodel1(maintainOrdersDetail)">确认维修
                    </Button>&nbsp;
                </div>

            </Card>
            <div style="height: 3px"></div>
            <!--                        <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0 16px' }">-->
            <!--                        </van-divider>-->
        </div>
<!--        <div>-->
<!--            <Modal-->
<!--                    v-model="modal1"-->
<!--                    title="完成维修"-->
<!--                    @on-ok="ok"-->
<!--                    @on-cancel="cancel">-->
<!--                <Form ref="maintainDeviceRecordRef" :model="maintainDeviceRecord" :label-width="50">-->
<!--                    <FormItem prop="content" label="主机号">-->
<!--                        <Select v-model="selectDevice">-->
<!--                            <Option v-for="item in devices" :value="item.terminalNum" :key="item.terminalNum">{{item.terminalNum}}</Option>-->
<!--                        </Select>-->
<!--                    </FormItem>-->
<!--                    <FormItem label="操作">-->
<!--                        <Checkbox :disabled="maintainDeviceRecord.removeDevice" v-model="maintainDeviceRecord.changeDevice"><span>更换设备</span></Checkbox>-->
<!--                        <Checkbox :disabled="maintainDeviceRecord.removeDevice" v-model="maintainDeviceRecord.changeSim"><span>更换SIM卡</span></Checkbox>-->
<!--                        <Checkbox :disabled="maintainDeviceRecord.changeDevice || maintainDeviceRecord.changeSim"-->
<!--                                  v-model="maintainDeviceRecord.removeDevice"><span>拆除设备</span></Checkbox>-->
<!--                    </FormItem>-->
<!--                    <FormItem v-if="maintainDeviceRecord.changeSim" prop="newTerminalNum" label="新设备主机号">-->
<!--                        <Input v-model="maintainDeviceRecord.newTerminalNum"></Input>-->
<!--                    </FormItem>-->
<!--                    <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newFactoryTerminalNum" label="新设备出厂主机号">-->
<!--                        <Input v-model="maintainDeviceRecord.newFactoryTerminalNum"></Input>-->
<!--                    </FormItem>-->
<!--                    <FormItem v-if="maintainDeviceRecord.changeDevice" prop="newPositioningDeviceModel" label="新设备型号">-->
<!--                        <Input v-model="maintainDeviceRecord.newPositioningDeviceModel"></Input>-->
<!--                    </FormItem>-->
<!--                </Form>-->
<!--            </Modal>-->
<!--        </div>-->

<!--        &lt;!&ndash;    指派维修员    &ndash;&gt;-->
<!--        <maintain-order-change-maintainer-modal v-model="maintainOrderChangeMaintainerModal" :initValue="maintainOrderChangeMaintainerId" @on-success="refresh"></maintain-order-change-maintainer-modal>-->
<!--        &lt;!&ndash;    指点业务员    &ndash;&gt;-->
<!--        <maintain-order-change-business-user-modal v-model="changeBusinessUserModal" :initValue="changeBusinessUserId" @on-success="refresh"></maintain-order-change-business-user-modal>-->
        <!--   添加维修记录     -->
        <maintain-order-add-maintain-device-record-modal v-model="maintainOrderAddMaintainDeviceRecordModal" :initValue="maintainOrderAddMaintainDeviceRecordId" on-success="refresh"></maintain-order-add-maintain-device-record-modal>
        <!--   删除维修记录     -->
        <maintain-order-delete-maintain-device-record-modal v-model="maintainOrderDeleteMaintainDeviceRecordModal"
                                                            :initValue="maintainOrderDeleteMaintainDeviceRecordId"
                                                            @on-success="refresh"></maintain-order-delete-maintain-device-record-modal>
        <!--   修改维修记录     -->
        <maintain-order-modify-maintain-device-record-modal v-model="maintainOrderModifyMaintainDeviceRecordModal"
                                                            :initValue="maintainOrderModifyMaintainDeviceRecordId"
                                                            @on-success="refresh"></maintain-order-modify-maintain-device-record-modal>
    </div>
</template>

<script>
    import MaintainOrderAddMaintainDeviceRecordModal from '../maintainOrders/components/maintain-order-add-maintain-device-record-modal'
    import MaintainOrderDeleteMaintainDeviceRecordModal
        from '../maintainOrders/components/maintain-order-delete-maintain-device-record-modal'
    import MaintainOrderModifyMaintainDeviceRecordModal from '../maintainOrders/components/maintain-order-modify-maintain-device-record-modal'
    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        NumberKeyboard,
    } from 'vant'


    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(NumberKeyboard)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast);

    export default {
        name: "maintainOrdersDetail",
        components:{
            MaintainOrderAddMaintainDeviceRecordModal,
            MaintainOrderDeleteMaintainDeviceRecordModal,
            MaintainOrderModifyMaintainDeviceRecordModal,

        },
        data() {
            return {
                // 增加设备维修记录
                maintainOrderAddMaintainDeviceRecordModal:false,
                maintainOrderAddMaintainDeviceRecordId:null,

                // 删除设备维修记录
                maintainOrderDeleteMaintainDeviceRecordModal: false,
                maintainOrderDeleteMaintainDeviceRecordId: null,

                // 修改设备维修记录
                maintainOrderModifyMaintainDeviceRecordModal: false,
                maintainOrderModifyMaintainDeviceRecordId: null,

                // 指定业务跟进
                changeBusinessUserModal: false,
                changeBusinessUserId: null,

                // 指派维修员
                maintainOrderChangeMaintainerModal: false,
                maintainOrderChangeMaintainerId: null,

                maintainOrdersDetail:[123,321],

                //修改表单
                maintainDeviceRecord: {
                    terminalNum: null,
                    newTerminalNum: null,
                    newFactoryTerminalNum: null,
                    newPositioningDeviceModel: null,
                    newPositioningDeviceModelId: null,
                    changeDevice: false,
                    changeSim: false,
                    removeDevice: false,
                    positioningDeviceInfoId: null,
                    positioningDeviceInfo: null,
                    result: null,
                    maintainOrderId: null,
                },

                modal1:false,
            }
        },
        methods: {
            ok(){

            },
            cancel(){

            },

            //刷新
            refresh(){
                store.dispatch('MaintainOrderServ_GetDetail', {
                    params: {
                        id: this.maintainOrderAddMaintainDeviceRecordId
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.maintainOrdersDetail = res.data
                }).catch((err) => {
                    console.log(err)
                })
            },

            //弹出确认框
            showmodel(e){
                console.log(e)
                this.maintainOrderAddMaintainDeviceRecordModal=true
                this.maintainDeviceRecord.maintainOrderId = e.id
                // store.dispatch('MaintainOrderServ_GetCanMakeRecordDevices', {
                //     params: {id: e.id},
                //     urlparams: null
                // }).then(() => {
                //     let devices = store.getters.get_MaintainOrder_GetCanMakeRecordDevicesResult
                //     console.log(devices)
                //     if (devices) {
                //         this.devices = devices
                //     }
                // }).catch(err => {
                //     this.$Message.error(err)
                // })
            },
            //弹出删除框
            showdeletemodel(e){
                console.log(e)
                this.maintainOrderDeleteMaintainDeviceRecordModal= true,
                    this.maintainOrderDeleteMaintainDeviceRecordId= e.id
            },
            showmodel1(e){
                this.maintainOrderModifyMaintainDeviceRecordModal = true
                this.maintainOrderModifyMaintainDeviceRecordId = e.id
            },
            //指定业务员
            assignSalesman(e){
                this.changeBusinessUserModal = true
                // this.changeBusinessUserId  = e.id
            },
            //指派维修员
            assignMaintenance(e){
                this.maintainOrderChangeMaintainerModal = true
                // this.maintainOrderChangeMaintainerId = e.id
            },

            //上传图片页
            toUploadermaintainOrdersDetail(e){
                this.$router.push({
                    // name: 'maintainOrders-Uploaderimage',
                    name: 'maintainOrders-UploaderImage-vant',
                    query: {'maintainOrdersUploaderimage': e.id}
                })
            },
            //返回上一页
            onback() {
                this.$router.push({
                    name: 'maintainOrders'
                })
            },
            getCode() { // 非静默授权，第一次有弹框
                let code = this.$route.query.code
                if (!code) {
                    code = null
                }
                // window.location.href = 'https://devwxpa.jianchengjt.com/?code=' + code
                // 你自己的业务逻辑
                //微信公众服务号登录
                store.dispatch('AccountServ_LoginByWechatServiceAccount', {
                    params: {
                        wechatCode: code
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    console.log('登陆成功')
                    // this.$router.push({
                    //     name: 'orderDetails',
                    // })
                })
                    .catch((err) => {
                        console.log(err)
                        console.log('登陆失败')
                        // this.$router.push({
                        //     name: 'login',
                        // })
                    })
            },
        },
        mounted() {
            console.log(this.$route.params.maintainOrdersDetailid)
            let id
            if (this.$route.query.code != null) {
                this.getCode()
                id = this.$route.query.maintainOrdersDetailid
            } else {
                id = this.$route.params.maintainOrdersDetailid
            }
this.maintainOrderAddMaintainDeviceRecordId = id
this.maintainOrderModifyMaintainDeviceRecordId = id
this.changeBusinessUserId = id
this.maintainOrderChangeMaintainerId = id
            store.dispatch('MaintainOrderServ_GetDetail', {
                params: {
                    id: id
                },
                urlparams: null
            }).then((res) => {
                console.log(res)
                this.maintainOrdersDetail = res.data
            }).catch((err) => {
                console.log(err)
            })
        }
    }
</script>

<style scoped>

    /*月售、送达时间、距离*/
    .content .mid {
        flex: 1;
        margin-top: 7px;
        color: #666;
        font-size: 12px;
    }
</style>
